import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import useRouterFilters from 'hooks/useRouterFilters';

import { SHIPPING_PRICES } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

/**
 * @author @muhammedburakak
 */

const NotInvoicedOrderList = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'ID',
				accessor: 'ID',
				filterType: FilterType.number,
				width: 70,
				show: false,
				showCopyButton: true
			},
			{
				Header: 'orderID',
				accessor: 'orderID',
				filterType: FilterType.number,
				showOnMobile: true,
				showCopyButton: true
			},
			{
				Header: 'clientName',
				accessor: 'clientName',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'createdDate',
				accessor: 'createdAt',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'city',
				accessor: 'cityName',
				filterType: FilterType.multiSelection
			},
			{
				Header: 'deliveryName',
				accessor: 'deliveryName',
				filterType: FilterType.string
			},
			{
				Header: 'shipmentID',
				accessor: 'shipmentID',
				filterType: FilterType.string,
				showCopyButton: true
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.multiSelection,
				width: 120,
				renderCell: ListComponents.STATUS,
				showOnMobile: true
			}
		],

		[]
	);

	const filtersFromRouter = useRouterFilters(columns);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.NOT_INVOICED_ORDERS}
				columns={columns}
				fetchUrl={SHIPPING_PRICES.GET_NOT_INVOICED_ORDERS_LIST}
				defaultFilters={filtersFromRouter}
				defaultSort={defaultSort}
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
				exportName="notInvoicedOrders"
			/>
		</TabTableContainer>
	);
};

export default NotInvoicedOrderList;
